import { createReducer } from 'redux-act'

import { OrderTotals } from '../types'
import * as actions from './actions'

const reducer = createReducer<OrderTotals>({}, {})

reducer.on(actions.setOrderTotals, (_, orderTotals) => ({
  ...orderTotals,
}))

export default reducer
